import {
  Alert,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useStaffList } from "../hooks/useStaffList";
import { Staff, StaffType, StaffTypeLabel } from "../types";

/** Support staff of one role (Staff → Directory, Staff tab); the role is picked in the page's top bar. */
export default function StaffList({ role }: { role: StaffType }) {
  const { staff, loading, error } = useStaffList(role);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      {error && <Alert severity="error">{error}</Alert>}

      {loading ? (
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <TableContainer className="mui-table-container-style">
          <Table size="small" className="mui-table-bordered">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {staff.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No {StaffTypeLabel[role].toLowerCase()} staff yet.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                staff.map((member: Staff, index) => (
                  <TableRow key={member.phone}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{member.name}</TableCell>
                    <TableCell>{member.gender}</TableCell>
                    <TableCell>{member.phone}</TableCell>
                    <TableCell>{member.email || "—"}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
